import {AxiosResponse} from 'axios'
import {FavoriteRequest, UnfavoriteResponse} from './types'
import {HttpInstance} from '../createHttpInstance'

export interface UnfavoritePhoto<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const unfavoritePhoto: UnfavoritePhoto<
  FavoriteRequest,
  UnfavoriteResponse
> = (http, params) => {
  const {ClientID, PersonID, PhotoID} = params

  const path = '/v1/photos/{photoid}/favorites/{personid}'
    .replace('{personid}', PersonID.toString())
    .replace('{photoid}', PhotoID.toString())

  return http.request<UnfavoriteResponse>({
    method: 'DELETE',
    url: `${path}?clientid=${ClientID}`,
  })
}
